import { render, staticRenderFns } from "./newbie_offer.vue?vue&type=template&id=5c5904ca&scoped=true"
import script from "./newbie_offer.vue?vue&type=script&lang=ts"
export * from "./newbie_offer.vue?vue&type=script&lang=ts"
import style0 from "./newbie_offer.vue?vue&type=style&index=0&id=5c5904ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5904ca",
  null
  
)

export default component.exports